module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-reservations"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('reservation-list-form', {
    attrs: {
      "type": 'entity-filter'
    },
    on: {
      "filterReservations": _vm.applyFilters
    }
  }), (_vm.$acl('vehicles-select-list') && _vm.$acl('index-common-cost')) ? _c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "data-toggle": "create-reservation"
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "driver-reservations tabs-inner-content no-space fill-bg"
  }, [(_vm.$acl('vehicles-select-list') && _vm.$acl('index-common-cost')) ? _c('div', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "is-hidden",
    attrs: {
      "id": "create-reservation",
      "data-toggler": "is-hidden"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Book for driver DR" + _vm._s(_vm.$route.params.id))]), _c('book-panel', {
    attrs: {
      "driverId": _vm.$route.params.id
    }
  })], 1) : _vm._e(), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Reservations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54a9c0eb!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/DriverReservations.vue
// module id = 2353
// module chunks = 1